// @flow

import ViewUtil from '../ViewUtil';
import Store from "../store/Store";
import { ASSET_LIST_BLOCK_INSTANCE } from "../store/Constants";
import System from '../basic/System';
import { isMobile } from './ScreenUtil';
import { CollectionActions, UIActions, ZoomActions } from './Constants';
import HashMap from '../protocol/HashMap';

export const UIActionToZoomActionsMap = new HashMap();
export const ZoomActionToUIActionsMap = new HashMap();
export const UIActionToCollectionActionsMap = new HashMap();
export const CollectionActionToUIActionMap = new HashMap();

export function getAssociatedAssetUIActions(zoomAction: ZoomActions) {
  if (UIActionToZoomActionsMap == null)
    UIActionToZoomActionsMap = new HashMap();

  if (UIActionToZoomActionsMap.containsKey(zoomAction)) {
    return UIActionToZoomActionsMap.get(zoomAction);
  }
  else {
    let uiActionList: Array<String> = getAssociatedUIActionsForZoomActions(zoomAction);
    UIActionToZoomActionsMap.put(zoomAction, uiActionList);
    return uiActionList;
  }
}

function getAssociatedUIActionsForZoomActions(zoomAction: ZoomActions) {
  switch (zoomAction) {
    case ZoomActions.RENAME:
      return [UIActions.RENAME];
    case ZoomActions.MOVE:
      return [UIActions.MOVE];
    case ZoomActions.LOCK:
      return [UIActions.LOCK];
    case ZoomActions.UNLOCK:
      return [UIActions.UNLOCK];
    case ZoomActions.CHECKOUT:
      return [UIActions.CHECKOUT];
    case ZoomActions.UPDATE:
      return [UIActions.UPDATE];
    case ZoomActions.NAVIGATION:
      return [UIActions.REVEAL_IN_EXPLORER, UIActions.VIEW_IN_ASSET_BROWSER];
    case ZoomActions.ARCHIVE:
      return [UIActions.ARCHIVE];
    case ZoomActions.RESTORE:
      return [UIActions.RESTORE];
    case ZoomActions.EDIT_METADATA:
      return [UIActions.EDIT_METADATA];
    case ZoomActions.SMART_COPY:
      return [UIActions.SMART_COPY];
    case ZoomActions.SMART_LINK:
      return [UIActions.SMART_LINK];
    case ZoomActions.DELETE:
      return [UIActions.DELETE];
    case ZoomActions.RESURRECT:
      return [UIActions.RESURRECT];
    case ZoomActions.CHECKIN:
      return [UIActions.UPLOAD, UIActions.DRAG_AND_DROP, UIActions.CREATE_NEW_ASSET, UIActions.CREATE_SEQUENCE_ASSET];
    case ZoomActions.PURGE:
      return [UIActions.PURGE];
    case ZoomActions.COPY_DETAILS:
      return [UIActions.COPY_ASSET_ID, UIActions.COPY_URL, UIActions.COPY_ASSET_PATH];
    case ZoomActions.CROPPING:
      return [UIActions.CROPPING];
    case ZoomActions.CLIPPING:
      return [UIActions.CLIPPING, UIActions.DOWNLOAD_CLIP, UIActions.CREATE_NEW_ASSET, UIActions.DOWNLOAD_XML_SEQUENCE,
      UIActions.DOWNLOAD_AVID_CAPTIONS, UIActions.DOWNLOAD_SRT, UIActions.DOWNLOAD_TEXT, UIActions.CREATE_SEQUENCE_ASSET];
    case ZoomActions.AI_DATA:
      return [UIActions.ADD_DATA_TIMELINE, UIActions.ADD_TIMELINE_ENTRY];
    case ZoomActions.COMPARE_VIEW:
      return [UIActions.COMPARE_VIEW];
    case ZoomActions.DELINK:
      return [UIActions.DELINK];
    case ZoomActions.MANAGE_EXTERNAL_ASSET:
      return UIActions.MANAGE_EXTERNAL_ASSET;  // [UIActions.REMOVE_FROM_MEDIA_STORE, UIActions.COPY_FROM_MEDIA_STORE_TO_S3, UIActions.COPY_FROM_S3_TO_MEDIA_STORE, UIActions.COPY_FROM_BACKUP_TO_S3];
    case ZoomActions.SHARE_VIA_EMAIL:
      return [UIActions.SHARE_VIA_EMAIL];
    case ZoomActions.ADD_TO_COLLECTION:
      return [UIActions.ADD_TO_COLLECTION];
    case ZoomActions.REMOVE_FROM_COLLECTION:
      return [UIActions.REMOVE_FROM_COLLECTION];
    case ZoomActions.ADD_TO_SPOTLIGHT:
      return [UIActions.ADD_TO_SPOTLIGHT];
    default:
      return [];
  }
}

export function getAssociatedZoomActions(uiAction: UIActions) {
  if (UIActionToZoomActionsMap == null)
    UIActionToZoomActionsMap = new HashMap();

  if (UIActionToZoomActionsMap.containsKey(uiAction)) {
    return UIActionToZoomActionsMap.get(uiAction);
  }
  else {
    let zoomActionList: Array<String> = getAssociatedZoomActionsForUIAction(uiAction);
    UIActionToZoomActionsMap.put(uiAction, zoomActionList);
    return zoomActionList;
  }
}

function getAssociatedZoomActionsForUIAction(uiAction: UIActions) {
  switch (uiAction) {
    case UIActions.RENAME:
      return [ZoomActions.RENAME];
    case UIActions.MOVE:
      return [ZoomActions.MOVE];
    case UIActions.LOCK:
      return [ZoomActions.LOCK];
    case UIActions.UNLOCK:
      return [ZoomActions.UNLOCK];
    case UIActions.CHECKOUT:
      return [ZoomActions.CHECKOUT];
    case UIActions.UPDATE:
      return [ZoomActions.UPDATE];
    case UIActions.VIEW_ASSET:
      return [];
    case UIActions.REVEAL_IN_EXPLORER:
      return [ZoomActions.NAVIGATION];
    case UIActions.ARCHIVE:
      return [ZoomActions.ARCHIVE];
    case UIActions.RESTORE:
      return [ZoomActions.RESTORE];
    case UIActions.EDIT_METADATA:
      return [ZoomActions.EDIT_METADATA];
    case UIActions.SMART_COPY:
      return [ZoomActions.SMART_COPY];
    case UIActions.SMART_LINK:
      return [ZoomActions.SMART_LINK];
    case UIActions.DELETE:
      return [ZoomActions.DELETE];
    case UIActions.RESURRECT:
      return [ZoomActions.RESURRECT];
    case UIActions.UPLOAD:
      return [ZoomActions.CHECKIN];
    case UIActions.DRAG_AND_DROP:
      return [ZoomActions.CHECKIN];
    case UIActions.VIEW_SPOTLIGHT:
      return [];
    case UIActions.ADD_TO_SPOTLIGHT:
      return [ZoomActions.ADD_TO_SPOTLIGHT];
    case UIActions.PURGE:
      return [ZoomActions.PURGE];
    case UIActions.ADD_TO_FAVORITES:
      return [];
    case UIActions.VIEW_FAVORITES:
      return [];
    case UIActions.REMOVE_FROM_FAVORITES:
      return [];
    case UIActions.COPY_ASSET_ID:
      return [ZoomActions.COPY_DETAILS];
    case UIActions.COPY_URL:
      return [ZoomActions.COPY_DETAILS];
    case UIActions.COPY_ASSET_PATH:
      return [ZoomActions.COPY_DETAILS];
    case UIActions.CROPPING:
      return [ZoomActions.CROPPING];
    case UIActions.CLIPPING:
      return [ZoomActions.CLIPPING];
    case UIActions.DOWNLOAD_CLIP:
      return [ZoomActions.DOWNLOAD_CLIP];
    case UIActions.CREATE_NEW_ASSET:
      return [ZoomActions.CLIPPING, ZoomActions.CHECKIN];
    case UIActions.DOWNLOAD_XML_SEQUENCE:
      return [ZoomActions.CLIPPING];
    case UIActions.DOWNLOAD_AVID_CAPTIONS:
      return [ZoomActions.CLIPPING];
    case UIActions.DOWNLOAD_SRT:
      return [ZoomActions.CLIPPING];
    case UIActions.DOWNLOAD_TEXT:
      return [ZoomActions.CLIPPING];
    case UIActions.CREATE_SEQUENCE_ASSET:
      return [ZoomActions.CLIPPING, ZoomActions.CHECKIN];
    case UIActions.ADD_TEXT:
      return [];
    case UIActions.PRESET_BASED_DOWNLOAD:
      return [];
    case UIActions.ADD_DATA_TIMELINE:
      return [ZoomActions.AI_DATA];
    case UIActions.ADD_TIMELINE_ENTRY:
      return [ZoomActions.AI_DATA];
    case UIActions.COMPARE_VIEW:
      return [ZoomActions.COMPARE_VIEW];
    case UIActions.VIEW_IN_ASSET_BROWSER:
      return [ZoomActions.NAVIGATION];
    case UIActions.DELINK:
      return [ZoomActions.DELINK];
    case UIActions.MANAGE_EXTERNAL_ASSET:
      return [ZoomActions.MANAGE_EXTERNAL_ASSET];
    case UIActions.REMOVE_FROM_MEDIA_STORE:
      return [ZoomActions.MANAGE_EXTERNAL_ASSET];
    case COPY_FROM_MEDIA_STORE_TO_S3:
      return [ZoomActions.MANAGE_EXTERNAL_ASSET];
    case COPY_FROM_S3_TO_MEDIA_STORE:
      return [ZoomActions.MANAGE_EXTERNAL_ASSET];
    case COPY_FROM_BACKUP_TO_S3:
      return [ZoomActions.MANAGE_EXTERNAL_ASSET];
    case UIActions.SHARE_VIA_EMAIL:
      return [ZoomActions.SHARE_VIA_EMAIL];
    case UIActions.ADD_TO_COLLECTION:
      return [ZoomActions.ADD_TO_COLLECTION];
    case UIActions.REMOVE_FROM_COLLECTION:
      return [ZoomActions.REMOVE_FROM_COLLECTION];
    default:
      return [];
  }
}

export function getAssociatedCollectionUIActions(collectionAction: CollectionActions) {
  if (CollectionActionToUIActionMap == null)
    CollectionActionToUIActionMap = new HashMap();

  if (CollectionActionToUIActionMap.containsKey(collectionAction)) {
    return CollectionActionToUIActionMap.get(collectionAction);
  }
  else {
    let uiActionList: Array<String> = getAssociatedUIActionsForCollectionActions(collectionAction);
    CollectionActionToUIActionMap.put(collectionAction, uiActionList);
    return uiActionList;
  }
}

function getAssociatedUIActionsForCollectionActions(collectionAction: CollectionActions) {
  switch (collectionAction) {
    case CollectionActions.SHARE_COLLECTION:
      return [UIActions.SHARE_AND_DOWNLOAD];
    case CollectionActions.DOWNLOAD_COLLECTION:
      return [UIActions.SHARE_AND_DOWNLOAD];
    case CollectionActions.ADD_TO_COLLECTION:
      return [UIActions.ADD_TO_COLLECTION];
    case CollectionActions.REMOVE_FROM_COLLECTION:
      return [UIActions.REMOVE_FROM_COLLECTION];
    case CollectionActions.COMMENTS:
      return [UIActions.ADD_COMMENT, UIActions.EDIT_COMMENT, UIActions.DELETE_COMMENT,
      UIActions.MARK_COMMENT_AS_RESOLVED, UIActions.ADD_REPLY, UIActions.EDIT_REPLY,
      UIActions.DELETE_REPLY];
    default:
      return [];
  }
}

export function getAssociatedCollectionActions(uiAction: UIActions) {
  if (UIActionToCollectionActionsMap == null)
    UIActionToCollectionActionsMap = new HashMap();

  if (UIActionToCollectionActionsMap.containsKey(uiAction)) {
    return UIActionToCollectionActionsMap.get(uiAction);
  }
  else {
    let collectionActionList: Array<String> = getAssociatedCollectionActionsForUIAction(uiAction);
    UIActionToCollectionActionsMap.put(uiAction, collectionActionList);
    return collectionActionList;
  }
}

function getAssociatedCollectionActionsForUIAction(uiAction: UIActions) {
  switch (uiAction) {
    case UIActions.SHARE_AND_DOWNLOAD:
      return [CollectionActions.SHARE_COLLECTION, CollectionActions.DOWNLOAD_COLLECTION];
    case UIActions.ADD_TO_COLLECTION:
      return [CollectionActions.ADD_TO_COLLECTION];
    case UIActions.REMOVE_FROM_COLLECTION:
      return [CollectionActions.REMOVE_FROM_COLLECTION];
    case UIActions.ADD_COMMENT:
      return [CollectionActions.COMMENTS];
    case UIActions.EDIT_COMMENT:
      return [CollectionActions.COMMENTS];
    case UIActions.DELETE_COMMENT:
      return [CollectionActions.COMMENTS];
    case UIActions.MARK_COMMENT_AS_RESOLVED:
      return [CollectionActions.COMMENTS];
    case UIActions.ADD_REPLY:
      return [CollectionActions.COMMENTS];
    case UIActions.EDIT_REPLY:
      return [CollectionActions.COMMENTS];
    case UIActions.DELETE_REPLY:
      return [CollectionActions.COMMENTS];
    default:
      return [];
  }
}

export function useWavePlayer() {
  const args = window.ARGS || {};
  return !!args.wp;
}

export function useNewImagePreview() {
  const args = window.ARGS || {};
  return args.scale !== 'false';
}

export function isPublicView() {
  const args = window.ARGS || {};
  return args.public === 'true';
}

export function showReportingTab() {
  const args = window.ARGS || {};
  return args.rpt === 'true';
}

export function canShowAssetsTab() {
  return !window.gs.linkSharingData && !window.gs.isExternalUser && !window.gs.isNoRoleUser;
}

export function canShowBrowseExtTab() {
  return canShowAssetsTab() && !isMobile();
}

export function canShowCollectionsTab() {
  return (
    !window.gs.linkSharingData &&
    !window.gs.isLinkUser
    //!window.gs.isExternalUser &&
    //!window.gs.isNoRoleUser
    //!ViewUtil.isDirectLinkToCollection()
  );
}

export function canShowSearchTab() {
  return !window.gs.linkSharingData && !window.gs.isExternalUser && !window.gs.isNoRoleUser;
}

export function canShowHomeTab() {
  return !window.gs.linkSharingData && !window.gs.isExternalUser && !window.gs.isNoRoleUser;
}

export function canShowSettingsTab() {
  return !window.gs.linkSharingData && !window.gs.isExternalUser && !window.gs.isNoRoleUser;
}

export function canShowVideoTimeline() {
  return window.ARGS.ai !== 'false';
}
